const galleryModalThumbOptions = {
  slidesPerView: 'auto',
  spaceBetween: 10,
  watchOverflow: true,
  centerInsufficientSlides: true,
  slideToClickedSlide: true,
};

const galleryModalMainOptions = {
  slidesPerView: 1,
  watchOverflow: true,
  autoHeight: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  thumbs: {
    swiper: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1023: {
      autoHeight: false,
    },
  },
};

const galleryModalInnerOptions = {
  slidesPerView: 1,
  watchOverflow: true,
  nested: true,
  spaceBetween: 40,
  allowTouchMove: false,
  simulateTouch: false,
};

const galleryModalInnerThumbOptions = {
  slidesPerView: 'auto',
  spaceBetween: 6,
  watchOverflow: true,
  centerInsufficientSlides: true,
  nested: true,
};

const getYoutubeId = (src) => {
  try {
    const url = new URL(src);

    if (url.hostname === 'youtu.be') {
      return url.pathname.slice(1) || null;
    }

    if (url.searchParams.has('v')) {
      return url.searchParams.get('v');
    }

    const match = url.pathname.match(/\/embed\/([^/?]+)/);
    return match?.[1] || null;
  } catch {
    return null;
  }
};

const toEmbedUrl = (src) => {
  const id = getYoutubeId(src);
  return id ? `https://www.youtube.com/embed/${id}` : src;
};

const ensureJsApi = (iframe) => {
  let url;
  try {
    url = new URL(toEmbedUrl(iframe.src));
  } catch {
    return;
  }

  url.searchParams.set('enablejsapi', '1');
  url.searchParams.set('origin', window.location.origin);

  if (iframe.src !== url.toString()) {
    iframe.src = url.toString();
  }
};

const replaceThumbIframesWithImages = (container) => {
  container?.querySelectorAll('.gallery-modal__inner-thumb-slide iframe').forEach((iframe) => {
    const videoId = getYoutubeId(iframe.src);
    if (!videoId) return;

    const img = document.createElement('img');
    img.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    img.alt = iframe.title || 'Video thumbnail';
    img.width = 953;
    img.height = 634;

    iframe.closest('.gallery-modal__iframe')?.replaceWith(img);
  });
};

const initYoutubePlayers = (container) => {
  if (!window.YT?.Player) return;

  container?.querySelectorAll('iframe').forEach((iframe) => {
    if (iframe.youtubePlayer) return;
    if (!getYoutubeId(iframe.src)) return;

    ensureJsApi(iframe);

    iframe.youtubePlayer = new YT.Player(iframe, {
      events: {
        onReady: () => {
          iframe.youtubeReady = true;

          if (iframe.youtubePendingStop) {
            iframe.youtubePendingStop = false;
            iframe.youtubePlayer.stopVideo();
          }
        },
      },
    });
  });
};

const initActiveSlideYoutube = (swiper) => {
  if (!swiper || !window.YT?.Player) return;

  const activeSlide = swiper.slides[swiper.activeIndex];
  initYoutubePlayers(activeSlide);
};

const stopYoutubeVideo = (iframe) => {
  const player = iframe?.youtubePlayer;

  if (!player) return;

  if (!iframe.youtubeReady) {
    iframe.youtubePendingStop = true;
    return;
  }

  player.stopVideo();
};

const stopAllVideos = (container) => {
  container?.querySelectorAll('iframe').forEach(stopYoutubeVideo);
};

const loadYoutubeApi = (onReadyCb) => {
  if (window.YT?.Player) {
    onReadyCb?.();
    return;
  }

  const previousReady = window.onYouTubeIframeAPIReady;

  window.onYouTubeIframeAPIReady = () => {
    previousReady?.();
    onReadyCb?.();
  };
};

const initGalleryModal = () => {
  replaceThumbIframesWithImages(document);

  const galleryModalMain = document.querySelectorAll('[data-slider="gallery-modal-main"]');
  const galleryModalThumb = document.querySelectorAll('[data-slider="gallery-modal-thumb"]');
  const galleryModalInner = document.querySelectorAll('[data-slider="gallery-modal-inner"]');
  const galleryModalInnerThumb = document.querySelectorAll('[data-slider="gallery-modal-inner-thumb"]');

  galleryModalThumb.forEach((el) => el.swiper?.destroy(true, true));
  galleryModalMain.forEach((el) => el.swiper?.destroy(true, true));
  galleryModalInner.forEach((el) => el.swiper?.destroy(true, true));
  galleryModalInnerThumb.forEach((el) => el.swiper?.destroy(true, true));

  galleryModalThumb.forEach((el) => new Swiper(el, galleryModalThumbOptions));

  galleryModalMain.forEach((el, i) => {
    const parentElem = el.closest('.gallery-modal');
    const arrowLeft = parentElem.querySelector('.swiper-button-prev');
    const arrowRight = parentElem.querySelector('.swiper-button-next');

    const mainSwiper = new Swiper(el, {
      ...galleryModalMainOptions,
      navigation: {
        prevEl: arrowLeft,
        nextEl: arrowRight,
      },
      thumbs: {
        swiper: galleryModalThumb[i]?.swiper || false,
      },
    });

    mainSwiper.on('slideChangeTransitionStart', () => {
      mainSwiper.slides.forEach((slide, index) => {
        if (index !== mainSwiper.activeIndex) {
          stopAllVideos(slide);
        }
      });

      loadYoutubeApi(() => initActiveSlideYoutube(mainSwiper));
    });
  });

  galleryModalInner.forEach((el, i) => {
    const innerMainSwiper = new Swiper(el, galleryModalInnerOptions);
    const innerThumbEl = galleryModalInnerThumb[i];
    if (!innerThumbEl) return;
    const innerThumbSwiper = new Swiper(innerThumbEl, galleryModalInnerThumbOptions);
    const setActiveThumb = (index) => {
      innerThumbSwiper.slides.forEach((slide, idx) => {
        slide.classList.toggle('swiper-slide-thumb-active', idx === index);
      });

      innerThumbSwiper.slideTo(index);
    };

    innerThumbSwiper.on('click', (swiper) => {
      if (swiper.clickedIndex === undefined) return;

      innerMainSwiper.slideTo(swiper.clickedIndex, 400);
    });

    innerMainSwiper.on('slideChange', () => {
      innerMainSwiper.slides.forEach((slide, index) => {
        if (index !== innerMainSwiper.activeIndex) {
          stopAllVideos(slide);
        }
      });

      setActiveThumb(innerMainSwiper.activeIndex);
      loadYoutubeApi(() => initActiveSlideYoutube(innerMainSwiper));
    });

    setActiveThumb(0);
  });

  loadYoutubeApi(() => {
    galleryModalMain.forEach((el) => initActiveSlideYoutube(el.swiper));
    galleryModalInner.forEach((el) => initActiveSlideYoutube(el.swiper));
  });
};

initGalleryModal();
window.initGalleryModal = initGalleryModal;

// Toggle Gallery Modal
const toggleModal = (element, toggle) => {
  const parentElement = element.closest('[data-modal-parent]');
  const parentId = element.closest('[data-id]')?.getAttribute('data-id');
  const modal = parentElement?.querySelector(`[data-modal]${parentId ? `[data-id="${parentId}"]` : ''}`);
  if (!modal) return;

  if (toggle) {
    loadYoutubeApi(() => {
      const mainSwiperEl = modal.querySelector('[data-slider="gallery-modal-main"]');
      initActiveSlideYoutube(mainSwiperEl?.swiper);

      modal.querySelectorAll('[data-slider="gallery-modal-inner"]').forEach((el) => {
        initActiveSlideYoutube(el.swiper);
      });
    });
  } else {
    stopAllVideos(modal);
  }

  modal.classList.toggle('is-open-modal', toggle);
  toggleBodyScrollLock(toggle);
};

// Close modal
attachEvent('[data-close-modal]', 'click', (ev) => {
  toggleModal(ev.target, false);
});

// Open modal
attachEvent('[data-gallery-trigger]', 'click', (ev) => {
  ev.preventDefault();
  toggleModal(ev.target, true);
});

// Close modal on Escape key
onKeydown('escape', () => {
  document.querySelectorAll('[data-modal].is-open-modal').forEach((modal) => {
    toggleModal(modal, false);
  });
});

attachEvent('[data-modal-slide]', 'click', (ev) => {
  const targetSlideEle = ev.target.closest('.gallery-card');
  const targetSlideAttr = targetSlideEle?.getAttribute('data-modal-slide');
  const parent = targetSlideEle?.closest('[data-modal-parent]');

  const mainSlider = parent?.querySelector('[data-slider="gallery-modal-main"]')?.swiper;

  if (targetSlideAttr && mainSlider) {
    mainSlider.slideTo(targetSlideAttr - 1, 0);
  }
});
